import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTiktokIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 100 100",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M74.66,20.573c-4.218-4.904-6.428-11.241-6.253-17.693L52.643,2.5c0,0,0,0.673,0,1.579v65.887 c-4.244,18.913-31.616,13.978-28.876-5.265c1.529-8.79,10.972-14.198,19.365-11.141c0,0,0-16.084,0-16.084 C24.861,34.295,7.546,48.837,7.728,67.364c1.597,40.179,59.226,40.185,60.825,0c-0.403-1.438-0.178-28.214-0.235-30.472 c7.168,4.46,15.508,6.689,23.954,6.405V26.685C84.464,26.685,78.505,24.609,74.66,20.573z" })
});
export { SvgTiktokIcon as ReactComponent };
